<div class="unauthorized">
  <div class="card unauthorized__card fade-up">
    <div class="unauthorized__icon">
      <wg-icon name="lock" [size]="24" />
    </div>
    <h1 class="unauthorized__title">Access required</h1>
    <p class="unauthorized__message">
      WatchGuard Studio can only be accessed via the Agent Hub portal.<br />
      Please log in and use the <strong>Studio</strong> button.
    </p>
    <a [href]="mainPortalUrl" class="btn btn-primary">Go to Agent Hub</a>
  </div>
</div>
